jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});



const video = document.getElementById("myVideo");

  // Function to set volume
//  function setVolume(volume) {
//    video.volume = volume;
//  }

  //volume
  setVolume(0.5);

  video.loop = true;
 // video.width = 100%;

//Autoplay the video
  video.autoplay = true;  
 video.load();


//function disableAutoplay() { 
//  video.autoplay = false;
//  video.load();
//} 

//function checkAutoplay() { 
//  alert(video.autoplay);
//} 